<template>
  <container title="平均出租率" style="height:450px;padding:24px;box-sizing:border-box;">
    <div class="bar fl">
        <!-- 仪盘表出租率 -->
        <div class="title">
        {{title}}
        </div>
        <div :id="id" style="width: 100%;height:300px;"></div>
    </div>
  </container>
  
</template>

<script>
  import container from "../../index/components/container";
  import echarts from 'echarts'
  export default {
    name: "bar",
    props: {
      title: String,
      data: String,
    },
    components: {
      container
    },
    data() {
      return {
        id: "bar" + Math.random(),
        flag: true,
      }
    },
    methods: {},

    created() {

    },
    mounted() {

    },
    watch: {
      data: function () {
        let data = this.data
        if (!this.flag) {
          return false
        }
        this.$nextTick(function () {
          this.flag = false
          var myChart = echarts.init(document.getElementById(this.id));
          let option = {
            backgroundColor: '#061033',
            series: [
              {
                name: '仪表盘',
                type: 'gauge',
                data: [{value: data, name: '出租率'}],
                radius: '100%',
                center: ['50%', '50%'],
                min: 0,
                max: 100,
                splitNumber: 5,
                axisLabel: {
                    formatter: function(e) {
                        switch (e + "") {
                            case "20":
                                return "差";
                            case "40":
                                return "中";
                            case "60":
                                return "良";
                            case "80":
                                return "优";
                            case "0":
                                return "";
                            case "100":
                                return "";
                            default:
                                return e;
                        }
                    },
                    textStyle: {
                        fontSize: 24,
                        color:"#f7f9fc",
                        fontWeight: ""
                    }
                },
                axisLine: {            // 坐标轴线
                    lineStyle: {       // 属性lineStyle控制线条样式
                        width: 30,
                        color: [[data / 100, '#3398DB'],
                        [1, "#f7f9fc"]]
                    }
                },
                axisTick: {            // 坐标轴小标记
                    length: 0,        // 属性length控制线长
                    lineStyle: {       // 属性lineStyle控制线条样式
                        color: 'auto'
                    }
                },
                splitLine: {           // 分隔线
                    length: 40,        // 属性length控制线长
                    lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                        color: 'auto'
                    }
                },
                detail: {
                  formatter:'{value}%',
                  fontSize: 24,
                  color: "#f7f9fc",
                  offsetCenter: [0, '85%']
                },
                title: {
                  fontSize: 24,
                  color: "#f7f9fc",
                  offsetCenter: [0, '55%']
                },
                pointer: {
                    show: true,
                    width: 5,
                    length: '40%'            // 指针大小
                },
                itemStyle:{
                    color: "#3193F7",
                    borderColor:"#3193F7",
                    borderWidth: 5
                },
              },
              {//指针外环
                        "type": 'pie',
                        "hoverAnimation": false,
                        "legendHoverLink": false,
                        "radius": ['5%', '13%'],
                        "z": 10,
                        "label": {
                            "normal": {
                                "show": false
                            }
                        },
                        "labelLine": {
                            "normal": {
                                "show": false
                            }
                        },
                        "data": [{
                            "value": 100,
                            itemStyle: {
                                normal: {
                                    color: '#3398DB'
                                }
                            }
                        }]
                    },
                    {//指针内环
                        "type": 'pie',
                        "hoverAnimation": false,
                        "legendHoverLink": false,
                        "radius": ['0%', '5%'],
                        "z": 10,
                        "label": {
                            "normal": {
                                "show": false
                            }
                        },
                        "labelLine": {
                            "normal": {
                                "show": false
                            }
                        },
                        "data": [{
                            "value": 100,
                            itemStyle: {
                                normal: {
                                    color: "#f7f9fc"
                                }
                            }
                        }]
                    }
            ]
            
          };

          myChart.setOption(option);
        })
      }
    },
  }
</script>

<style scoped lang="scss">
  .bar {
    width: 100%;
    height: 400px;
    background-color: #061033;
    .title {
      font-size: 16px;
      color: #B8D7FF;
      font-weight: 700;
      width: 600px;
      padding-left:24px;
      padding-top: 30px;
    }
  }
</style>
